import Tooltip from 'rc-tooltip';
import raf from 'rc-util/lib/raf';
import { useEffect, useRef, useState } from 'react';

function HandleTooltip(
  props: Readonly<{
    value: number;
    children: React.ReactElement;
    visible: boolean;
    suffix?: string;
  }>
) {
  const { value, children, visible, suffix, ...restProps } = props;

  const [isMounted, setIsMounted] = useState(false); // Need this for the react-tooltip

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const tooltipRef = useRef<any>();
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (visible) {
      raf.cancel(rafRef.current!);
    } else {
      rafRef.current = raf(() => {
        tooltipRef.current?.forcePopupAlign();
      });
    }

    return raf.cancel(rafRef.current!);
  }, [value, visible]);

  const tooltipContentFormatter = (v: string | number) =>
    `${v.toLocaleString()}${suffix ? ' ' + suffix : ''}`;

  if (!isMounted) return null;
  return (
    <Tooltip
      overlay={tooltipContentFormatter(value)}
      ref={tooltipRef}
      visible={visible}
      {...restProps}
    >
      {children}
    </Tooltip>
  );
}

export default HandleTooltip;
